"use strict";

export function initInScope ($scope) {
    $scope.find('.js-collapsing-checkbox__input').on('change',function (e) {

        if ($(this).prop('checked')) {
            $(this).closest('.js-collapsing-checkbox').find('.js-collapsing-checkbox__add:first').removeAttr('hidden');
        } else {
            $(this).closest('.js-collapsing-checkbox').find('.js-collapsing-checkbox__add:first').attr('hidden','hidden');
            $(this).closest('.js-collapsing-checkbox').find('.js-collapsing-checkbox__add:first input').prop('checked',false);
            $(this).closest('.js-collapsing-checkbox').find('.js-collapsing-checkbox__add:first select option').prop('selected',false);
            $(this).closest('.js-collapsing-checkbox').find('.js-collapsing-checkbox__add:first input:not(.js-keep-collapsing-value)').val('').removeClass('has-value');

            /* if collapse detail added */
            $(this).closest('.js-collapsing-checkbox').find('.js-collapse-detail-container__add').attr('hidden','hidden');

            if ($(this).hasClass('js-collapsing-checkbox__input--close-all')) {

                $(this).closest('.js-collapse-detail-container').find('.js-hidden-input-list-item').attr('hidden','hidden').addClass('is-hidden');
                $(this).closest('.js-collapse-detail-container').find('input').val('').removeClass('has-value');
                $(this).closest('.js-collapse-detail-container').find('select option').prop('selected',false);

                $(this).closest('.js-collapse-detail-container').find('.form-group').removeClass('has-value');

                $(this).closest('.js-collapse-detail-container').find('.js-show-hidden-input').removeAttr('hidden','hidden');
            }
        }
    });

    if ($('.js-collapsing-checkbox__input').prop('checked')) {
        $(this).closest('.js-collapsing-checkbox').find('.js-collapsing-checkbox__add:first').removeAttr('hidden');
    }





    /* open area on load if checked */
    $scope.find('.js-collapsing-checkbox__input').each(function(){
        let $this = $(this);
        if($this.prop('checked')) {
            $(this).closest('.js-collapsing-checkbox').find('.js-collapsing-checkbox__add:first').removeAttr('hidden');
        }
    });
}